import { QueuedRequest } from "./types";

let isRefreshing = false;
let failedQueue: QueuedRequest[] = [];

export const isTokenRefreshing = (): boolean => isRefreshing;

export const setTokenRefreshing = (refreshing: boolean): void => {
    isRefreshing = refreshing;
};

export const queueRequest = (): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        failedQueue.push({ resolve, reject });
    });
};
export const processQueue = (error: unknown, newToken: string | null): void => {
    failedQueue.forEach((promise) => {
        if (error) {
            promise.reject(error);
        } else if (newToken) {
            promise.resolve(newToken);
        }
    });
    failedQueue = [];
};

export const getQueueLength = (): number => failedQueue.length;
